export const categories = [
  { slug: 'mingxing', name: '明星黑料', icon: 'ri-star-line', description: '娱乐圈明星最新爆料与丑闻' },
  { slug: 'wanghong', name: '网红爆料', icon: 'ri-live-line', description: '网红圈内幕与争议事件' },
  { slug: 'zongyi', name: '综艺内幕', icon: 'ri-tv-line', description: '综艺节目背后的秘密' },
  { slug: 'yingshi', name: '影视圈', icon: 'ri-film-line', description: '电影电视剧圈内八卦' },
  { slug: 'yinyue', name: '音乐圈', icon: 'ri-music-line', description: '音乐圈艺人动态与争议' },
  { slug: 'tiyu', name: '体育圈', icon: 'ri-basketball-line', description: '体育明星花边新闻' },
];

export const articles = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时',
    slug: 'top-star-hotel-date',
    category: 'mingxing',
    excerpt: '据知情人士透露，近日某顶流男星在横店拍戏期间，深夜与一名神秘女子在酒店密会长达8小时。该女子疑似圈内新人演员...',
    content: `<p>据知情人士透露，近日某顶流男星在横店拍戏期间，深夜与一名神秘女子在酒店密会长达8小时。该女子疑似圈内新人演员，两人此前曾在某综艺节目中有过合作。</p><p>据酒店工作人员爆料，当晚11点左右，该男星独自驾车抵达酒店地下车库，随后一名戴着口罩和帽子的女子从侧门进入。两人一前一后进入电梯，直到次日早上7点才先后离开。</p><p>值得关注的是，该男星上个月刚在社交媒体上公开表示"目前单身，专注事业"，此番被拍到密会女子，引发粉丝强烈不满。</p><p>有网友扒出该神秘女子疑似是某选秀节目出身的新人演员林某某，两人曾在去年的一档音乐综艺中有过互动。当时两人在节目中的亲密互动就曾引发过热议。</p><h3>粉丝反应两极分化</h3><p>消息传出后，该男星的粉丝群体出现了明显的分裂。一部分粉丝表示"爱豆也有私生活"，另一部分则认为"欺骗粉丝不可原谅"。短短几小时内，相关话题就冲上了热搜榜首。</p><p>目前，该男星及其工作室尚未对此事作出回应。我们将持续关注事件进展。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20scene%20of%20a%20celebrity%20entering%20a%20luxury%20hotel%20at%20night%2C%20dim%20street%20lights%2C%20paparazzi%20style%20photography%2C%20dramatic%20moody%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20blurred%20background%20with%20hotel%20entrance%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-1&orientation=landscape',
    publishedAt: '2026-08-06T02:30:00Z',
    views: 128000,
    comments: 3542,
    author: '八卦小能手',
    tags: ['顶流男星', '恋情曝光', '酒店密会', '粉丝脱粉'],
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '某选秀女团成员被曝与经纪人恋爱，公司紧急公关',
    slug: 'girl-group-dating-agent',
    category: 'mingxing',
    excerpt: '知名选秀女团人气成员被拍到与经纪人牵手逛街，两人举止亲密。粉丝炸锅，公司连夜发布声明...',
    content: `<p>知名选秀女团人气成员被拍到与经纪人牵手逛街，两人举止亲密。粉丝炸锅，公司连夜发布声明称"只是工作关系"。</p><p>据目击者称，当天下午在市中心商圈看到该女团成员与一名男子手牵手逛街，两人有说有笑，完全不避讳旁人目光。该男子随后被认出是负责该成员的经纪人王某。</p><p>照片在网络上迅速传播，粉丝们纷纷表示"塌房了"。有人扒出该经纪人已婚，这让事情变得更加复杂。</p><h3>公司声明引发更大争议</h3><p>经纪公司在深夜发布声明，称两人只是"正常的工作陪同关系"，并表示将追究偷拍者的法律责任。然而这份声明非但没有平息舆论，反而引发了更大的质疑。</p><p>不少网友指出，照片中两人十指相扣、互喂冰淇淋的行为已经远远超出了"工作关系"的范畴。截至目前，该女团成员的社交账号评论区已经沦陷。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20female%20idol%20walking%20hand%20in%20hand%20with%20a%20man%20on%20a%20busy%20shopping%20street%2C%20paparazzi%20candid%20shot%20style%2C%20natural%20daylight%2C%20urban%20background%2C%20dramatic%20lighting%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-2&orientation=landscape',
    publishedAt: '2026-08-05T18:00:00Z',
    views: 96000,
    comments: 2891,
    author: '瓜田里的猹',
    tags: ['选秀女团', '经纪人', '恋情曝光', '塌房'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '某大主播直播间翻车，涉嫌虚假宣传被平台封禁',
    slug: 'streamer-fake-promo-banned',
    category: 'wanghong',
    excerpt: '拥有千万粉丝的某带货主播在直播中涉嫌虚假宣传产品功效，被网友举报后遭平台封禁30天，品牌方紧急解约...',
    content: `<p>拥有千万粉丝的某带货主播在直播中涉嫌虚假宣传产品功效，被网友举报后遭平台封禁30天，品牌方紧急解约。</p><p>事情发生在本周三晚上的直播中。该主播在推销一款"美白精华"时，声称产品"使用7天就能白三个度"，并展示了一张明显经过PS处理的对比图。</p><p>直播间有观众当场质疑对比图的真实性，该主播不仅没有解释，反而怒怼质疑者"不懂就不要乱说"，态度极其恶劣。这段视频被网友录屏后在网上疯传。</p><h3>平台出手封禁</h3><p>随着舆论发酵，多个消费者维权账号转发该视频，引发了更大范围的关注。平台方在接到大量举报后，于周四下午对该主播账号进行了封禁处理，为期30天。</p><p>同时，与其合作的三个美妆品牌也紧急发布声明，宣布与该主播终止合作。据业内人士估计，这次翻车事件可能给该主播带来超过千万的损失。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20live%20streaming%20studio%20with%20a%20streamer%20looking%20shocked%20in%20front%20of%20a%20camera%2C%20dramatic%20red%20and%20dark%20lighting%2C%20beauty%20products%20on%20display%2C%20screens%20showing%20negative%20comments%2C%20cinematic%20tense%20atmosphere%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-3&orientation=landscape',
    publishedAt: '2026-08-05T10:00:00Z',
    views: 215000,
    comments: 5230,
    author: '吃瓜一线',
    tags: ['带货主播', '虚假宣传', '平台封禁', '直播间翻车'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '某综艺节目录制现场爆发冲突，两位嘉宾大打出手',
    slug: 'variety-show-fight',
    category: 'zongyi',
    excerpt: '据现场观众爆料，某热门综艺在最新一期录制过程中，两位常驻嘉宾因为游戏环节产生争执，最后演变成肢体冲突...',
    content: `<p>据现场观众爆料，某热门综艺在最新一期录制过程中，两位常驻嘉宾因为游戏环节产生争执，最后演变成肢体冲突。</p><p>该节目是一档以"真实对抗"为卖点的竞技类综艺。录制当天，在最后一个游戏环节中，两位嘉宾因为对规则理解不同产生分歧。起初只是口头争论，随后其中一人突然推了对方一把，场面瞬间失控。</p><p>据现场观众描述，工作人员花了将近五分钟才将两人分开。节目导演当场宣布暂停录制，整个录制现场气氛一度非常尴尬。</p><h3>节目组紧急回应</h3><p>事件发酵后，节目组官方发布声明，表示会对此事进行内部调查，并会根据调查结果决定是否保留两位嘉宾的常驻资格。同时，该期节目是否播出也成为悬念。</p><p>有业内人士分析，这可能是节目组的一次"炒作"，因为该节目近期的收视率一直在下滑。但也有知情人士坚称，冲突是真实的，两位嘉宾之间的矛盾由来已久。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20on%20a%20TV%20show%20set%20with%20two%20celebrities%20arguing%20intensely%2C%20studio%20lights%20and%20cameras%20in%20the%20background%2C%20crew%20members%20rushing%20to%20intervene%2C%20tense%20atmosphere%2C%20cinematic%20composition%2C%20warm%20studio%20lighting%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-4&orientation=landscape',
    publishedAt: '2026-08-04T22:00:00Z',
    views: 187000,
    comments: 4102,
    author: '圈内老鬼',
    tags: ['综艺', '冲突', '嘉宾打架', '节目录制'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '某知名导演被多名女演员实名举报性骚扰',
    slug: 'director-harassment-allegations',
    category: 'yingshi',
    excerpt: '三位女演员先后在社交媒体发文，实名举报某知名导演在片场多次对其进行言语和行为上的骚扰，引发影视圈震动...',
    content: `<p>三位女演员先后在社交媒体发文，实名举报某知名导演在片场多次对其进行言语和行为上的骚扰，引发影视圈震动。</p><p>第一位站出来的女演员张某在长文中详细描述了该导演在2019年拍摄某部电影时，多次以"讲戏"为由将她单独叫到房间，并做出不当行为。她表示当时因为害怕影响事业而选择了沉默。</p><p>随后，另外两位女演员也分别发声，描述了类似的遭遇。三人指控的时间跨度长达五年，涉及多部影视作品。</p><h3>行业震动</h3><p>消息传出后，中国电影导演协会发布声明，表示将对此事进行调查。多个正在与该导演合作的项目也紧急暂停。该导演至今未作出任何回应，但其社交账号已经关闭了评论功能。</p><p>这起事件再次引发了公众对影视行业权力滥用问题的关注。多位业内人士呼吁建立行业监督机制，保护演员的合法权益。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20serious%20scene%20of%20a%20film%20set%20with%20a%20director%20chair%20empty%20under%20harsh%20spotlight%2C%20metaphorical%20image%20of%20power%20and%20silence%2C%20dramatic%20shadows%2C%20cinematic%20noir%20style%2C%20moody%20atmosphere%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-5&orientation=landscape',
    publishedAt: '2026-08-04T15:00:00Z',
    views: 352000,
    comments: 8790,
    author: '正义吃瓜人',
    tags: ['知名导演', '性骚扰', '实名举报', '女演员'],
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '某说唱歌手新歌被指抄袭，原作者发律师函',
    slug: 'rapper-plagiarism-accusation',
    category: 'yinyue',
    excerpt: '上周发布新专辑的说唱歌手被指主打歌抄袭某韩国独立音乐人的作品，原作者已通过律师发函要求下架并赔偿...',
    content: `<p>上周发布新专辑的说唱歌手被指主打歌抄袭某韩国独立音乐人的作品，原作者已通过律师发函要求下架并赔偿。</p><p>音乐博主"旋律侦探"在社交平台发布了一段对比视频，将两首歌的旋律进行逐段对比。视频显示，该说唱歌手的主打歌与韩国音乐人去年发布的某首歌在旋律走向上有超过70%的相似度。</p><p>这段对比视频迅速走红，播放量在24小时内突破了500万。网友们纷纷表示"这不是借鉴，这是复制粘贴"。</p><h3>法律行动</h3><p>韩国原创作者方面在得知此事后，已经委托中国律师向该说唱歌手及其唱片公司发出了律师函，要求立即下架侵权歌曲，并赔偿经济损失。</p><p>目前，该说唱歌手方面并未正面回应抄袭指控，但其经纪公司发表声明称"正在与法律团队沟通，会妥善处理"。多个音乐平台已经暂时下架了该歌曲。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20rap%20music%20studio%20with%20headphones%20and%20sheet%20music%20on%20a%20desk%2C%20dramatic%20red%20and%20blue%20lighting%20split%2C%20creative%20tension%20between%20originality%20and%20copying%2C%20dark%20atmosphere%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-6&orientation=landscape',
    publishedAt: '2026-08-04T09:00:00Z',
    views: 89000,
    comments: 2150,
    author: '音乐圈内人',
    tags: ['说唱歌手', '抄袭', '律师函', '下架'],
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '某知名运动员被曝出轨，妻子深夜发文"心碎了"',
    slug: 'athlete-cheating-scandal',
    category: 'tiyu',
    excerpt: '某奥运冠军被拍到与一名模特在酒店约会，其妻子凌晨在社交平台发文"心碎了"，随后删除。粉丝纷纷表示不敢相信...',
    content: `<p>某奥运冠军被拍到与一名模特在酒店约会，其妻子凌晨在社交平台发文"心碎了"，随后删除。粉丝纷纷表示不敢相信。</p><p>据娱乐记者拍摄的照片显示，该运动员上周五晚与一名年轻女子在某五星级酒店的餐厅共进晚餐，随后两人一同进入电梯前往客房楼层。照片中两人的举止十分亲密。</p><p>该运动员与妻子结婚五年，育有一子，一直以来都是体育圈的"模范夫妻"。此次出轨传闻令众多粉丝感到震惊。</p><h3>妻子深夜发文</h3><p>在照片曝光的当晚凌晨两点，该运动员的妻子在社交平台发布了一条动态，只有三个字："心碎了"。虽然这条动态在十分钟后被删除，但已经被大量网友截图保存。</p><p>截至目前，该运动员本人保持沉默，其经纪人表示"不便回应"。多个其代言的品牌已经开始评估是否需要调整合作关系。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxury%20hotel%20restaurant%20scene%20with%20a%20sportsman%20and%20a%20young%20woman%20dining%20together%2C%20dim%20romantic%20lighting%2C%20paparazzi%20hidden%20camera%20style%2C%20elegant%20setting%2C%20dramatic%20mood%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-7&orientation=landscape',
    publishedAt: '2026-08-03T20:00:00Z',
    views: 298000,
    comments: 6450,
    author: '体育圈八卦',
    tags: ['奥运冠军', '出轨', '婚姻危机', '品牌代言'],
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    title: '某古装剧主演被曝片场耍大牌，全组苦不堪言',
    slug: 'actor-diva-behavior',
    category: 'yingshi',
    excerpt: '正在热拍的古装剧《长安夜》被曝主演频繁迟到、要求特殊待遇，导致拍摄进度严重滞后，剧组工作人员怨声载道...',
    content: `<p>正在热拍的古装剧《长安夜》被曝主演频繁迟到、要求特殊待遇，导致拍摄进度严重滞后，剧组工作人员怨声载道。</p><p>据剧组内部人员透露，该剧男主角自开拍以来，已经累计迟到超过50小时。除了迟到，他还要求剧组为其准备独立的化妆间、专属厨师，甚至连片场的温度都需要精确控制在他要求的范围内。</p><p>有工作人员匿名抱怨："全组几百号人等他一个，每次迟到都是几个小时，化妆师、摄影师、群众演员全都得干等着。"</p><h3>导演态度引争议</h3><p>更令人气愤的是，导演对这些行为选择了默许甚至纵容。有消息称，该主演是投资方指定的，导演也没有办法。目前，该剧的拍摄进度已经比原计划晚了将近一个月。</p><p>此事被曝光后，该主演的粉丝纷纷为其辩护，称"优秀演员值得更好的待遇"。而路人网友则对这种"耍大牌"行为表示强烈不满。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20drama%20film%20set%20with%20an%20empty%20director%20chair%20and%20crew%20waiting%20impatiently%2C%20traditional%20costumes%20and%20set%20design%2C%20frustrated%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20wide%20shot%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-8&orientation=landscape',
    publishedAt: '2026-08-03T14:00:00Z',
    views: 167000,
    comments: 3890,
    author: '片场观察员',
    tags: ['古装剧', '耍大牌', '片场', '主演迟到'],
    isHot: true,
    isNew: false,
  },
  {
    id: 9,
    title: '某顶流网红偷税被罚，金额高达千万级',
    slug: 'influencer-tax-evasion',
    category: 'wanghong',
    excerpt: '税务部门公布最新一批偷逃税案例，某知名直播带货网红被追缴税款加罚款共计超过3000万元，账号已被全网封禁...',
    content: `<p>税务部门公布最新一批偷逃税案例，某知名直播带货网红被追缴税款加罚款共计超过3000万元，账号已被全网封禁。</p><p>根据税务部门通报，该网红在2021年至2025年期间，通过设立多家空壳公司、签订阴阳合同等方式隐匿个人收入，偷逃个人所得税款超过1800万元。加上滞纳金和罚款，合计金额超过3000万元。</p><p>该网红此前一直以"接地气"、"朴实"的人设吸引粉丝，直播间常年位居平台带货榜前十。此次偷税丑闻曝光后，粉丝们纷纷表示"人设崩塌"。</p><h3>行业整顿信号</h3><p>业内人士分析，此次查处是税务部门对直播行业进行规范化管理的一部分。据悉，目前还有多位头部主播正在接受税务调查。</p><p>该网红的社交账号已被全网封禁，其经营的多家公司也被列入经营异常名录。此案也给整个直播行业敲响了警钟。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxury%20lifestyle%20scene%20with%20stacks%20of%20money%20and%20tax%20documents%20on%20a%20marble%20table%2C%20dramatic%20contrast%20between%20wealth%20and%20legal%20trouble%2C%20dark%20moody%20lighting%20with%20red%20accents%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-9&orientation=landscape',
    publishedAt: '2026-08-02T11:00:00Z',
    views: 432000,
    comments: 9870,
    author: '财经八卦哥',
    tags: ['网红', '偷税漏税', '封禁', '直播行业'],
    isHot: true,
    isNew: false,
  },
  {
    id: 10,
    title: '某歌手演唱会假唱被观众当场揭穿，场面尴尬',
    slug: 'singer-lip-sync-caught',
    category: 'yinyue',
    excerpt: '在某歌手巡回演唱会现场，因为技术故障导致伴奏突然中断，歌手仍在对口型的画面被大屏幕实时播出，观众哗然...',
    content: `<p>在某歌手巡回演唱会现场，因为技术故障导致伴奏突然中断，歌手仍在对口型的画面被大屏幕实时播出，观众哗然。</p><p>事情发生在本周六晚的演唱会中段。当该歌手演唱其成名曲时，音响系统突然出现故障，伴奏音乐在中途停止。然而，该歌手没有意识到发生了什么，继续在舞台上做着"演唱"的动作，而现场没有任何歌声传出。</p><p>整个过程被现场的大屏幕实时播出，台下数千名观众看得清清楚楚。现场先是一片死寂，随后爆发出一片哗然和嘘声。</p><h3>主办方紧急道歉</h3><p>事故发生后，演唱会主办方紧急暂停了演出，并发布声明称是因为"歌手身体不适"才使用辅助音轨。但这一解释并未被观众接受。</p><p>许多观众要求退票，并在社交平台上发起了维权话题。截至目前，该歌手已关闭了社交账号的评论功能。这次事件也被业内人士称为"2026年最尴尬的演唱会事故"。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20large%20concert%20stage%20with%20a%20singer%20looking%20shocked%20and%20embarrassed%2C%20bright%20stage%20lights%2C%20huge%20LED%20screen%20in%20background%2C%20massive%20audience%2C%20dramatic%20moment%20of%20technical%20failure%2C%20cinematic%20wide%20shot%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-10&orientation=landscape',
    publishedAt: '2026-08-02T08:00:00Z',
    views: 521000,
    comments: 14320,
    author: '现场观众甲',
    tags: ['演唱会', '假唱', '技术故障', '退票'],
    isHot: true,
    isNew: false,
  },
  {
    id: 11,
    title: '某女星被前助理爆料私下脾气暴躁，经常辱骂工作人员',
    slug: 'actress-bad-temper-exposed',
    category: 'mingxing',
    excerpt: '一位自称曾是某当红女星助理的网友发长文爆料，称自己工作期间遭受了长达两年的精神虐待，被当众辱骂是家常便饭...',
    content: `<p>一位自称曾是某当红女星助理的网友发长文爆料，称自己工作期间遭受了长达两年的精神虐待，被当众辱骂是家常便饭。</p><p>该前助理在文中详细描述了多个令人震惊的事件。包括因为买的咖啡温度不对而当众被骂"废物"，因为忘记带备用的高跟鞋被骂"养你有什么用"，甚至有一次因为下雨没及时撑伞被该女星用手里的包砸了一下。</p><p>该助理表示，两年的工作经历让她患上了严重的焦虑症，离职后花了很长时间才恢复。她选择现在发声，是因为看到该女星最近在节目中大谈"尊重每一个工作人员"，感到极度讽刺。</p><h3>圈内人纷纷站队</h3><p>该爆料发布后，多位自称与该女星合作过的幕后工作人员也在评论区留言，证实了这些说法。但也有几位曾与之合作过的演员为该女星说话，称"她只是要求严格"。目前该女星方面尚未回应。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20glamorous%20female%20celebrity%20looking%20angry%20backstage%20at%20a%20fashion%20event%2C%20dramatic%20contrast%20between%20her%20elegant%20appearance%20and%20furious%20expression%2C%20dark%20backstage%20setting%2C%20cinematic%20portrait%20style%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-11&orientation=landscape',
    publishedAt: '2026-08-01T19:00:00Z',
    views: 245000,
    comments: 5670,
    author: '幕后真相',
    tags: ['女星', '助理爆料', '辱骂工作人员', '人设崩塌'],
    isHot: true,
    isNew: false,
  },
  {
    id: 12,
    title: '两大人气综艺被曝收视率造假，电视台内部调查',
    slug: 'tv-ratings-fraud',
    category: 'zongyi',
    excerpt: '某省级卫视两档王牌综艺节目被曝长期通过样本户操控收视率数据，电视台已启动内部调查，相关责任人被停职...',
    content: `<p>某省级卫视两档王牌综艺节目被曝长期通过样本户操控收视率数据，电视台已启动内部调查，相关责任人被停职。</p><p>收视率造假一直是电视行业的顽疾。此次被曝光的两档节目是该卫视收视率最高的综艺，在广告招商中一直以"收视冠军"自居。然而，一份内部举报材料显示，这些高收视率数据是人为操控的结果。</p><p>据举报人透露，节目组会向部分样本户支付费用，让他们在特定时间段锁定该频道，从而人为抬高收视率。这种做法已经持续了至少两年。</p><h3>广告商要求赔偿</h3><p>消息曝光后，多家在该节目投放广告的品牌方表示关注，部分品牌已经向电视台发出质询函，要求核实收视率数据的真实性。如果造假属实，广告商可能要求退还广告费并索取赔偿。</p><p>目前，该电视台已经成立专项调查组，多名节目制作人员被暂时停职。广电总局也表示将对此事保持关注。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20TV%20control%20room%20with%20monitors%20showing%20rating%20charts%20and%20graphs%2C%20tense%20atmosphere%2C%20dark%20room%20with%20glowing%20screens%2C%20corporate%20scandal%20theme%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-12&orientation=landscape',
    publishedAt: '2026-08-01T10:00:00Z',
    views: 156000,
    comments: 3120,
    author: '媒体观察者',
    tags: ['收视率造假', '综艺', '电视台', '内部调查'],
    isHot: false,
    isNew: false,
  },
  {
    id: 13,
    title: '某网红情侣分手互撕，私密聊天记录全网疯传',
    slug: 'couple-breakup-drama',
    category: 'wanghong',
    excerpt: '拥有500万粉丝的网红情侣宣布分手后，双方在社交平台互发长文控诉对方，大量私密聊天记录被曝光，引发全网吃瓜...',
    content: `<p>拥有500万粉丝的网红情侣宣布分手后，双方在社交平台互发长文控诉对方，大量私密聊天记录被曝光，引发全网吃瓜。</p><p>这对网红情侣曾是圈内有名的"神仙眷侣"，两人从2023年开始交往，经常在各大平台发布甜蜜日常，还共同创立了一个情侣账号，粉丝超过500万。</p><p>然而，分手消息来得猝不及防。女方先发长文控诉男方在恋爱期间多次出轨，并附上了多张聊天记录截图。男方随即反击，爆料女方曾向他的朋友借钱不还，并公开了催债聊天记录。</p><h3>全网围观</h3><p>两人你来我往的"互撕大战"持续了整整三天，每条动态下都有数十万条评论。网友们分成两派，各执一词。有人心疼女方，有人同情男方，更多的是纯吃瓜看热闹。</p><p>事件中，两人的情侣账号已经停止更新，数百万粉丝关注的账号或将就此消失。不少品牌方也紧急撤下了与两人相关的合作内容。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20split%20screen%20showing%20a%20young%20couple%20turning%20away%20from%20each%20other%20on%20social%20media%2C%20smartphone%20with%20chat%20messages%2C%20emotional%20breakup%20scene%2C%20dramatic%20contrast%20lighting%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-13&orientation=landscape',
    publishedAt: '2026-07-31T22:00:00Z',
    views: 387000,
    comments: 11230,
    author: '吃瓜小分队',
    tags: ['网红情侣', '分手', '互撕', '聊天记录'],
    isHot: false,
    isNew: false,
  },
  {
    id: 14,
    title: '某电影因主演丑闻被紧急撤档，损失或超5亿',
    slug: 'movie-canceled-scandal',
    category: 'yingshi',
    excerpt: '原定暑期档上映的某投资5亿的奇幻大片因主演卷入严重丑闻被紧急撤档，投资方损失惨重，导演公开发文表达无奈...',
    content: `<p>原定暑期档上映的某投资5亿的奇幻大片因主演卷入严重丑闻被紧急撤档，投资方损失惨重，导演公开发文表达无奈。</p><p>这部电影筹备三年，拍摄周期长达八个月，是今年最受期待的国产奇幻大片之一。然而，就在上映前两周，该片男主角因涉嫌严重违法行为被警方带走调查。</p><p>片方在事件发生后的24小时内紧急召开会议，最终决定无限期推迟影片上映日期。据知情人士透露，片方正考虑使用AI技术替换该演员的镜头，但这一方案的技术难度和成本都非常高。</p><h3>行业连锁反应</h3><p>此次事件引发了整个影视行业对演员"塌房险"的讨论。多家保险公司表示正在研究推出相关保险产品，以帮助投资方规避演员个人行为带来的风险。</p><p>导演在社交平台发文表达无奈："一部作品凝聚了上千人的心血，现在却因为一个人的问题毁于一旦。这个行业的风险太大了。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20movie%20poster%20being%20torn%20down%20from%20a%20theater%20wall%2C%20dramatic%20shadows%2C%20empty%20cinema%20hallway%2C%20canceled%20movie%20theme%2C%20cinematic%20moody%20atmosphere%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-14&orientation=landscape',
    publishedAt: '2026-07-31T15:00:00Z',
    views: 278000,
    comments: 6340,
    author: '电影圈内参',
    tags: ['电影撤档', '主演丑闻', '投资损失', '塌房险'],
    isHot: false,
    isNew: false,
  },
  {
    id: 15,
    title: '某体育明星被拍到夜店狂欢至凌晨，次日比赛表现失常',
    slug: 'athlete-nightclub-scandal',
    category: 'tiyu',
    excerpt: '在某重要比赛前一晚，某体育明星被拍到在某夜店狂欢至凌晨四点，第二天比赛表现一塌糊涂，教练赛后怒斥其不职业...',
    content: `<p>在某重要比赛前一晚，某体育明星被拍到在某夜店狂欢至凌晨四点，第二天比赛表现一塌糊涂，教练赛后怒斥其不职业。</p><p>据目击者拍摄的视频显示，该运动员在周五凌晨出现在某知名夜店的VIP包厢内，与多名友人饮酒作乐。而此时距离周六下午的重要比赛仅剩不到36小时。</p><p>周六的比赛中，该运动员状态全无，全场失误频频，最终导致队伍以悬殊比分落败。赛后新闻发布会上，主教练虽然未点名批评，但表示"某些队员的职业道德令人失望"。</p><h3>俱乐部开出罚单</h3><p>事件被曝光后，该运动员所在的俱乐部宣布对其进行队内处罚，包括罚款和禁赛两场。俱乐部官方声明称将加强对运动员的纪律管理。</p><p>球迷们对此反应不一，有人认为处罚太轻，也有人呼吁给年轻运动员改过自新的机会。该运动员本人已在社交平台公开道歉。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20nightclub%20scene%20with%20colorful%20lights%20and%20dancing%20crowd%2C%20a%20sportsman%20in%20VIP%20area%2C%20contrast%20with%20empty%20stadium%20field%20next%20day%2C%20dramatic%20before%20and%20after%20vibe%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-15&orientation=landscape',
    publishedAt: '2026-07-30T20:00:00Z',
    views: 198000,
    comments: 4560,
    author: '球圈速递',
    tags: ['体育明星', '夜店', '比赛失常', '队内处罚'],
    isHot: false,
    isNew: false,
  },
  {
    id: 16,
    title: '某综艺节目被指恶意剪辑，嘉宾集体发声维权',
    slug: 'variety-show-malicious-editing',
    category: 'zongyi',
    excerpt: '五位曾参加过某综艺的嘉宾联合发声，指控节目组通过恶意剪辑制造矛盾、歪曲事实，严重损害了他们的公众形象...',
    content: `<p>五位曾参加过某综艺的嘉宾联合发声，指控节目组通过恶意剪辑制造矛盾、歪曲事实，严重损害了他们的公众形象。</p><p>这五位嘉宾曾分别在不同季的该综艺中担任嘉宾。他们在联合声明中指出，节目组通过有选择性地剪辑素材、添加引导性的字幕和音效，制造了大量不存在的"矛盾"和"冲突"。</p><p>其中一位嘉宾表示，节目中呈现的"怼人"片段实际上是被剪辑了前后语境，原话是善意的玩笑，但被剪辑后完全变了味道。这导致他在节目播出后遭到了长达数月的网络暴力。</p><h3>节目组回应</h3><p>面对指控，节目组发表声明称所有剪辑都是"为了节目效果"，否认恶意剪辑的说法，称嘉宾们都签过合同，同意节目组拥有最终剪辑权。</p><p>这一回应引发了更大的争议。多位法律人士指出，即使合同约定了剪辑权，但如果剪辑导致了名誉损害，嘉宾依然有权追究责任。目前，双方正在进一步协商中。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20video%20editing%20suite%20with%20multiple%20monitors%20showing%20the%20same%20scene%20cut%20differently%2C%20manipulation%20concept%2C%20dark%20room%20with%20glowing%20screens%2C%20dramatic%20cinematic%20look%2C%20no%20text%2C%20no%20watermark&width=800&height=450&seq=article-cover-16&orientation=landscape',
    publishedAt: '2026-07-30T12:00:00Z',
    views: 134000,
    comments: 2890,
    author: '综艺打假',
    tags: ['综艺', '恶意剪辑', '嘉宾维权', '网络暴力'],
    isHot: false,
    isNew: false,
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleById = (id: number) => {
  return articles.find((a) => a.id === id);
};

export const getHotArticles = () => {
  return articles.filter((a) => a.isHot);
};

export const getNewArticles = () => {
  return articles.filter((a) => a.isNew);
};

export const getRelatedArticles = (article: typeof articles[0], count: number = 3) => {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, count);
};